import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Calendar } from 'lucide-react';
import { Button } from '../components/ui/button';

const NewsDetailPage = () => {
  const { slug } = useParams();

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  // In a real app, you'd fetch the post by slug from the API
  // For now, we'll show a placeholder
  return (
    <div className="min-h-screen pt-24">
      <article className="py-16 lg:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Link to="/news" className="inline-flex items-center text-primary hover:text-primary/80 mb-8">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to News
            </Link>

            <div className="space-y-6">
              <span className="inline-block px-3 py-1 rounded-full bg-primary/10 text-primary text-sm">
                Category
              </span>
              
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground font-['Outfit'] leading-tight">
                News Article Title
              </h1>

              <div className="flex items-center gap-4 text-muted-foreground">
                <span className="flex items-center gap-1">
                  <Calendar className="h-4 w-4" />
                  December 15, 2025
                </span>
              </div>

              <div className="aspect-video rounded-2xl overflow-hidden bg-card">
                <img 
                  src="https://images.unsplash.com/photo-1553363335-be71737fd158?w=1200"
                  alt="Article"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="prose prose-invert max-w-none">
                <p className="text-lg text-muted-foreground leading-relaxed">
                  This is a placeholder for the full news article content. In a production environment, 
                  this would be fetched from the database based on the article slug.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  The article would include all the details about the news item, event, or announcement.
                  It could include images, formatting, and links to related content.
                </p>
              </div>

              <div className="pt-8 border-t border-border">
                <Link to="/news">
                  <Button variant="outline" className="rounded-full">
                    <ArrowLeft className="mr-2 h-4 w-4" />
                    Back to All News
                  </Button>
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </article>
    </div>
  );
};

export default NewsDetailPage;
